module.exports = __webpack_public_path__ + "img/blog-5-1.0d25eaaa.webp";